<script>
import { userRoleIds } from '@/helpers/constants';

export default {
	computed: {
		userData() {
			return this.$store.getters.userData;
		},
		isAdmin() {
			const adminRoles = [
				userRoleIds.SUPER_ADMIN,
				userRoleIds.USA_ADMIN,
				userRoleIds.JA_AREA_ADMIN
			];

			return (
				this.userData && adminRoles.includes(parseInt(this.userData.roleId))
			);
		},
		isSuperAdmin() {
			return (
				this.userData &&
				parseInt(this.userData.roleId) == userRoleIds.SUPER_ADMIN
			);
		},
		isUSAAdmin() {
			return (
				this.userData && parseInt(this.userData.roleId) == userRoleIds.USA_ADMIN
			);
		}
	}
};
</script>
